import { render, staticRenderFns } from "./main-menu.html?vue&type=template&id=5e7a5076&scoped=true&"
import script from "./main-menu.js?vue&type=script&lang=js&"
export * from "./main-menu.js?vue&type=script&lang=js&"
import style0 from "./main-menu.css?vue&type=style&index=0&id=5e7a5076&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7a5076",
  null
  
)

export default component.exports